import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private darkMode = new BehaviorSubject<boolean>(this.getInitialTheme());
  isDarkMode$ = this.darkMode.asObservable();

  constructor() {
    this.applyTheme(this.darkMode.value);
  }

  private getInitialTheme(): boolean {
    return localStorage.getItem('darkMode') === 'enabled';
  }

  setDarkMode(isDark: boolean) {
    if (isDark) {
      localStorage.setItem('darkMode', 'enabled');
      localStorage.setItem('themeMode', 'active');
    } else {
      localStorage.setItem('darkMode', 'disabled');
      localStorage.setItem('themeMode', 'inactive');
    }
    
    this.darkMode.next(isDark);
    this.applyTheme(isDark);
  }

  private applyTheme(isDark: boolean) {
    const body = document.body;

    if (isDark) {
      body.classList.add('active-body', 'dark-mode');
    } else {
      body.classList.remove('active-body', 'dark-mode');
    }
  }
}